module.exports = __webpack_public_path__ + "static/dwarf-fighter-MGZN_DRGN_378-41e125804bd7bed2b7bd3a29d6d0f723.webp";